const XL_BREAKPOINT = 1280;
const query = window.matchMedia(`(max-width: ${XL_BREAKPOINT - 0.02}px)`);

Alpine.store('viewport', {
    isMobile: query.matches,
});

query.addEventListener('change', (event) => {
    Alpine.store('viewport').isMobile = event.matches;
});
